export enum FeatureFlag {
  DashboardCustomRoles = 'dashboard-custom-roles',
  EnableAchTransferBatches = 'enable-ach-transfer-batches',
  EnableBankAccountsSearch = 'enable-bank-accounts-search',
  EnableCustomCSVStatements = 'enable-custom-csv-statements',
  EnableDeviceMFA = 'enable-device-mfa',
  EnableLiveModeMfaRequired = 'enable-live-mode-mfa-required',
  EnablePaniniCheckScanner = 'enable-panini-check-scanner',
  EnableTransferApprovals = 'enable-transfer-approvals',
  EnableTransferApprovalPage = 'enable-transfer-approval-page',
  EnableTransferBatches = 'enable-transfer-batches',
  HasInternationalWires = 'has-international-wires',
}
